import { m } from "framer-motion"
import { Col } from 'react-bootstrap'
// import { getMeetingMinutes, getPad, getProjectDocuments, getStudyReports } from "../../Store/Publication/publication"
// import { useQuery } from "@tanstack/react-query"
// import Tiles from "./Components/Tiles"
// import Loading from "../../Components/Loading"
const Publication = () => {
//     const { data: padData, isLoading: isLoadingPad } = useQuery({
//         queryKey: ['padData'],
//         queryFn: () => getPad(),
//         refetchOnWindowFocus: false,
//         refetchOnMount: true,
//     });
//     const { data: studyReportsData, isLoading: isLoadingStudyReports } = useQuery({
//         queryKey: ['studyReportsData'],
//         queryFn: () => getStudyReports(),
//         refetchOnWindowFocus: false,
//         refetchOnMount: true,
//     });
//     const { data: meetingMinutesData, isLoading: isLoadingMeetingMinutes } = useQuery({
//         queryKey: ['meetingMinutesData'],
//         queryFn: () => getMeetingMinutes(),
//         refetchOnWindowFocus: false,
//         refetchOnMount: true,
//     });
//     const { data: projectDocumentsData, isLoading: isLoadingProjectDocuments } = useQuery({
//         queryKey: ['projectDocumentsData'],
//         queryFn: () => getProjectDocuments(),
//         refetchOnWindowFocus: false,
//         refetchOnMount: true,
//     });
//     if (isLoadingPad ||
//         isLoadingStudyReports ||
//         isLoadingMeetingMinutes ||  
//         isLoadingProjectDocuments) return (<Loading />)
    return (
        <>

            <m.div className='container  mt-[200px] '>
                <Col xl={8} lg={10} className="text-center w-fit">
                    <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">Publications</h3>
                    <m.div
                        className="border-b border-1 w-[40%] border-[#146084]"
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: 1 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    />
                </Col>

                {/* <Tiles data={padData?.data} title={'PAD'} />
                <Tiles data={meetingMinutesData?.data} title={'Meeting Minutes'} />
                <Tiles data={projectDocumentsData?.data} title={'Project Documents'} />
                <Tiles data={studyReportsData?.data} title={'Study Reports'} /> */}
            </m.div >
        </>
    )
}

export default Publication    